import { createApiRef } from '@backstage/core-plugin-api';
import { FeatureFlagsApi } from './flags';

/**
 * Frontend-only API ref. Import from
 * `@internal/plugin-feature-flags-common/api` — do not pull this into the
 * backend entrypoint (Node/CJS cannot load @backstage/core-plugin-api ESM).
 */
export const featureFlagsApiRef = createApiRef<FeatureFlagsApi>({
  id: 'plugin.feature-flags.service',
});
